import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconHeadphones } from "@tabler/icons-react";
import { Button, Message } from "../../components";

interface DjBarProps {
  isDj: boolean;
  onLogin: (code: string) => Promise<void>;
  onLogout: () => void;
}

export const DjBar = ({ isDj, onLogin, onLogout }: DjBarProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const close = () => {
    setOpen(false);
    setCode("");
    setError(false);
  };

  const submit = async () => {
    setSubmitting(true);
    setError(false);
    try {
      await onLogin(code.trim());
      close();
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  if (isDj) {
    return (
      <div className="dj-bar">
        <span className="dj-badge">
          <IconHeadphones />
          {t("dj.djMode")}
        </span>
        <button type="button" className="dj-link" onClick={onLogout}>
          {t("dj.logout")}
        </button>
      </div>
    );
  }

  return (
    <div className="dj-bar">
      <button
        type="button"
        className="dj-link"
        onClick={() => setOpen(true)}
        aria-label={t("dj.djLogin")}
      >
        <IconHeadphones />
        <span>{t("dj.dj")}</span>
      </button>
      {open && (
        <div
          className="dj-modal-scrim"
          role="presentation"
          onClick={close}
        >
          <div
            className="dj-modal"
            role="dialog"
            aria-modal="true"
            aria-label={t("dj.djLogin")}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="dj-modal-title">{t("dj.djLogin")}</h3>
            <input
              className="dj-pin-input"
              type="password"
              inputMode="numeric"
              autoComplete="off"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder={t("dj.pinPrompt")}
              aria-label={t("dj.pinPrompt")}
              onKeyDown={(e) => {
                if (e.key === "Enter" && code.trim().length >= 4) submit();
              }}
            />
            {error && <Message variant="error">{t("dj.pinWrong")}</Message>}
            <div className="dj-modal-actions">
              <Button
                appearance="outline"
                onClick={close}
                disabled={submitting}
              >
                {t("dj.cancel")}
              </Button>
              <Button
                onClick={submit}
                disabled={submitting || code.trim().length < 4}
              >
                {t("dj.enter")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
